<template>
  <div>
    <div class="go-back">
      <el-page-header
        @back="goBack"
        :content="this.$route.query.scenic_tit + '-门票设置'"
      />
    </div>
    <div>
      <ele-form
        v-model="formData"
        :form-desc="formDesc"
        :request-fn="handleSubmit"
        :rules="rules"
        :isShowBackBtn="false"
        @request-success="handleSuccess"
      />
    </div>
  </div>
</template>

<script>
import * as scenic from "@/api/product/scenic.js";
import * as Category from "@/api/product/category.js";
import * as ticket from "@/api/product/ticket.js";
import * as supplier from "@/api/product/supplier.js";
export default {
  data() {
    return {
      formData: {},
      formDesc: {
        thumb: {
          required: true,
          label: "缩略图",
          type: "image-uploader",
          attrs: {
            size: 100,
            accept: "jpg,jpeg,png",
            action: this.$uploadURL,
            headers: {
              authorization: sessionStorage.getItem("token")
            },
            responseFn(response, file) {
              if (response.code !== 200) {
                this.$message.error(response.msg);
              }
              // 根据响应结果, 设置 URL
              return response.data.url;
            },
            lazy: true,
            fileSize: 1
          },
          layout: 24
        },
        ticket_name: {
          required: true,
          type: "input",
          layout: 24,
          label: "产品名称"
        },
        platform: {
          label: "销售平台",
          type: "checkbox",
          layout: 18,
          options: [
            {
              text: "微信",
              value: "weixin"
            },
            {
              text: "抖音",
              value: "toutiao"
            },
            {
              text: "支付宝",
              value: "alipay"
            }
          ]
        },
        ticket_code: {
          required: true,
          type: "input",
          layout: 12,
          label: "产品编码"
        },
        title: {
          required: true,
          type: "input",
          layout: 12,
          label: "区域名称"
        },
        area_code: {
          required: true,
          type: "input",
          label: "区域编码",
          layout: 12
        },
        play_date: {
          layout: 12,
          type: "time",
          label: "场次时间",
          attrs: {
            arrowControl: true,
            pickerOptions: {
              selectableRange: "18:30:00 - 24:30:00",
              start: "00:00",
              step: "00:05",
              end: "24:00"
            }
          }
        },
        session_code: {
          layout: 12,
          required: true,
          type: "input",
          label: "场次编码"
        },
        category_id: {
          layout: 12,
          type: "select",
          label: "分类",
          options: async () => {
            let res = await Category.addCategoryselects.r();
            let temp = [];
            for (let index = 0; index < res.list.length; index++) {
              temp.push({
                text: res.list[index].scenic + "-" + res.list[index].title,
                value: res.list[index].id
              });
            }
            return temp;
          }
        },
        item_id: {
          layout: 12,
          type: "select",
          required: true,
          label: "供应商",
          options: async () => {
            let res = await supplier.addSupplierselects.r();
            let temp = [];
            for (let index = 0; index < res.list.length; index++) {
              temp.push({
                text: res.list[index].title,
                value: res.list[index].id
              });
            }
            return temp;
          }
        },
        type: {
          required: true,
          label: "类型",
          type: "select",
          default: "theatre",
          layout: 12,
          options: [
            {
              text: "景区门票",
              value: "scenic"
            },
            {
              text: "剧院门票",
              value: "theatre"
            }
          ]
        },
        price: {
          required: true,
          type: "number",
          label: "原价",
          layout: 12,
          attrs: {
            min: 1,
            precision: 2,
            controls: false
          }
        },
        discounts: {
          required: true,
          type: "number",
          label: "优惠价",
          layout: 12,
          attrs: {
            min: 1,
            precision: 2,
            controls: false
          }
        },
        is_sku: {
          required: true,
          label: "库存模式",
          //   1不限库存2总库存
          layout: 12,
          type: "radio",
          default: 0,
          options: [
            {
              text: "产品库存",
              value: 0
            },
            {
              text: "日历库存",
              value: 1
            }
          ]
        },
        sku: {
          required: true,
          type: "number",
          label: "库存",
          layout: 12,
          attrs: {
            min: 0,
            controls: false
          },
          vif(data) {
            return data.is_sku === 0;
          }
        },
       
        is_cart: {
          required: true,
          label: "购物车",
          layout: 12,
          type: "select",
          default: 0,
          options: [
            {
              text: "启用",
              value: 1
            },
            {
              text: "禁用",
              value: 0
            }
          ]
        },
        link_ticket: {
          label: "关联门票",
          layout: 12,
          type: "select",
          default: 0,
          attrs: {
            multiple: true
          },
          options: async () => {
            let res = await scenic.getTicketSelect.r({
              scenic_id: this.id
            });
            let temp = [];
            for (let index = 0; index < res.list.length; index++) {
              temp.push({
                text: res.list[index].label,
                value: res.list[index].value
              });
            }
            return temp;
          },
          vif(data) {
            return data.is_cart == '1';
          }
        },
        min_num: {
          required: true,
          type: "number",
          label: "最少预订量",
          layout: 12,
          attrs: {
            min: 1
          }
        },
        max_num: {
          required: true,
          type: "number",
          label: "最多预订量",
          layout: 12,
          attrs: {
            min: 0
          }
        },
        cover: {
          required: true,
          label: "图集",
          type: "image-uploader",
          attrs: {
            // drag: true, // 多张
            multiple: true,
            size: 100,
            accept: "jpg,jpeg,png",
            action: this.$uploadURL,
            headers: {
              authorization: sessionStorage.getItem("token")
            },
            responseFn(response, file) {
              if (response.code !== 200) {
                this.$message.error(response.msg);
              }
              // 根据响应结果, 设置 URL
              return response.data.url;
            },
            lazy: true
          },
          layout: 24
        },
        tips: {
          type: "tag",
          label: "门票标签",
          options: ["随买随用", "需取票"]
        },
        garden: {
          required: true,
          type: "textarea",
          label: "入园信息"
        },
        sales: {
          required: true,
          type: "textarea",
          label: "销售限制"
        },
        contains: {
          type: "textarea",
          label: "包含说明"
        },
        note: {
          type: "textarea",
          label: "其他说明"
        },
        sorting: {
          layout: 12,
          required: true,
          type: "number",
          label: "排序",
          attrs: {
            min: 1
          }
        },
        status: {
          layout: 12,
          required: true,
          label: "状态",
          //   0启用1禁用
          type: "radio",
          default: 0,
          options: [
            {
              text: "启用",
              value: 0
            },
            {
              text: "禁用",
              value: 1
            }
          ]
        }
      },
      rules: {},
      id: this.$route.query.id,
      scenic_id: this.$route.query.scenic_id,
      scenic_tit: this.$route.query.scenic_tit
    };
  },
  created() {
    if (this.$route.query.ticket_id) {
      ticket.getTicketInfo.r({ id: this.$route.query.ticket_id }).then(res => {
        this.formData = res;
      });
    }
  },
  methods: {
    handleSubmit(form) {
      form["scenic_id"] = this.scenic_id;
      if (this.id == -1) {
        ticket.addTicket.r(form).then(res => {
          this.isGoBack();
        });
      } else {
        ticket.editTicket.r(form).then(res => {
          this.$message.success("修改成功");
          this.isGoBack();
        });
      }
    },
    handleSuccess() {},
    isGoBack() {
      this.$confirm("设置成功，是否留在此页?", "提示", {
        confirmButtonText: "返回上一页",
        cancelButtonText: "留在此页",
        type: "success"
      })
        .then(() => {
          this.$router.go(-1);
        })
        .catch(() => {});
    },

    goBack() {
      this.$confirm("返回上一页并不会保存修改进度，是否继续？", "提示！", {
        confirmButtonText: "返回上一页",
        cancelButtonText: "留在此页",
        type: "warning"
      })
        .then(() => {
          this.$router.go(-1);
        })
        .catch(() => {});
      console.log("go back");
    }
  }
};
</script>

<style lang="scss" scoped>
.go-back {
  // position: -webkit-sticky; /* safari 浏览器 */
  // position: sticky; /* 其他浏览器 */
  // top: 0px;
  // z-index: 9999;
  background-color: #fff;
}
</style>
